import { useMemo } from 'react'
import { useOptionalPartnerContext } from '@retailer-platform/dashboard/utils'
import { FeatureEntitlements } from '../../access-control/featureEntitlements'

/**
 * Checks if the current partner has the partner bulk delivery entitlement.
 *
 * Uses the partner context (aggregated across all warehouses) to determine whether
 * the Equipment Data experience should be shown instead of the legacy pick-devices
 * view. The Vehicles tab within Equipment Data is further gated at the individual
 * warehouse level via useCanViewVehicles.
 */
export const useIsPartnerBulkDeliveryEnabled = () => {
  const partnerContext = useOptionalPartnerContext()

  return useMemo(() => {
    if (!partnerContext?.loaded) {
      return false
    }

    return (
      partnerContext.featureEntitlements?.some(
        e => e.id === FeatureEntitlements.PartnerBulkDeliveryEnabled
      ) ?? false
    )
  }, [partnerContext])
}
